import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';

function App() {
  const [corePrice, corePriceSet] = useState(120);
  const [partsPrice, partsPriceSet] = useState(890);

  const [serniumPrice, serniumPriceSet] = useState(450);
  const [arcsPrice, arcsPriceSet] = useState(900);
  const [odiumPrice, odiumPriceSet] = useState(1200);
  const [dowonPrice, dowonPriceSet] = useState(1200);
  const [arteriaPrice, arteriaPriceSet] = useState(1050);
  const [karcionPrice, karcionPriceSet] = useState(1500);
  const [arcainPrice, arcainPriceSet] = useState(480);

  const [mepocon, mepoconSet] = useState(3000);

  const [symbolName, setSymbolName] = useState("아르테리아");
  const [meso, setMeso] = useState(0);
  const [core, setCore] = useState(0);
  const [parts, setParts] = useState(0);
  const [symbol, setSymbol] = useState(0);

  const [result, setResult] = useState(0);
  const [mepo, setMepo] = useState(0);

  const SYMBOL = {
    SERNIUM: '세르니움',
    ARCS: '아르크스',
    ODIUM: '오디움',
    DOWON: '도원경',
    ARTERIA: '아르테리아',
    KARCION: '카르시온',
    ARCANE: '아케인'
  }
  
  const getSymbolPrice = (symbolName) => {
    switch(symbolName) {
      case SYMBOL.SERNIUM:
        return serniumPrice;
        
      case SYMBOL.ARCS:
        return arcsPrice;
        
      case SYMBOL.ODIUM:
        return odiumPrice;
        
      case SYMBOL.DOWON:
        return dowonPrice;
        
      case SYMBOL.ARTERIA:
        return arteriaPrice;
        
      case SYMBOL.KARCION:
        return karcionPrice;
        
      case SYMBOL.ARCANE:
        return arcainPrice;
        
      default:
        return 0;
    }
  }

  useEffect(() => {
    let nowSymbol = getSymbolPrice(symbolName);

    setResult(
      parseInt(meso*10000)
      + parseInt(core) * parseInt(corePrice)
      + parseInt(parts) * parseInt(partsPrice)
      + parseInt(symbol) * parseInt(nowSymbol)
    )

    setMepo(
      (parseInt(meso*10000)
        + parseInt(core) * parseInt(corePrice)
        + parseInt(parts) * parseInt(partsPrice)
        + parseInt(symbol) * parseInt(nowSymbol)) * parseInt(mepocon) / 10000
    );
  }, [meso, core, parts, symbol, symbolName, corePrice, partsPrice, serniumPrice, arcsPrice, odiumPrice, dowonPrice, arteriaPrice, karcionPrice, arcainPrice]);

  return (
    <div id='base'>
      <div id='main'>
        <div id='warning'>※ 억 단위 소수점 입력 ※</div>

        <div id='inputBox'>
          <text id='label'>메소(억)</text>
          <input id='resultInput' value={meso} type='number' onChange={(e) => setMeso(e.target.value)} />
        </div>

        <div id='inputBox'>
          <text id='label'>코어젬스톤</text>
          <input id='resultInput' value={core} type='number' onChange={(e) => setCore(e.target.value)} />
        </div>

        <div id='inputBox'>
          <text id='label'>솔 에르다 조각</text>
          <input id='resultInput' value={parts} type='number' onChange={(e) => setParts(e.target.value)} />
        </div>

        <div id='inputBox'>
          <text id='label'>심볼</text>
          <div>
            <select id='select' value={symbolName} onChange={(e) => setSymbolName(e.target.value)}>
              <option value='아케인'>아케인</option>
              <option value='세르니움'>세르니움</option>
              <option value='아르크스'>아르크스</option>
              <option value='오디움'>오디움</option>
              <option value='도원경'>도원경</option>
              <option value='아르테리아'>아르테리아</option>
              <option value='카르시온'>카르시온</option>
            </select>
            <input id='ratioInput' type='number' value={symbol} onChange={(e) => setSymbol(e.target.value)} />
          </div>
        </div>

        <div>
          <div id='resultBox'>
            <text id='label'>Meso</text>
            <text id='result'>{result} 만</text>
          </div>
          <div id='inputBox'>
            <text id='label'>메포</text>
            <text id='result'>{mepo} 원</text>
          </div>
        </div>
      </div>
      <div id='main2'>
        <div id='inputBox'>
          <text id='label'>1억당 메포</text>
          <input id='resultInput' value={mepocon} type='number' onChange={(e) => mepoconSet(e.target.value)} />
        </div>

        <h5 class='center'>경매장 시세</h5>
        <div id='inputBox'>
          <text id='label'>코어젬스톤</text>
          <input id='resultInput' value={corePrice} type='number' onChange={(e) => corePriceSet(e.target.value)} />
        </div>
        <div id='inputBox'>
          <text id='label'>솔 에르다 조각</text>
          <input id='resultInput' value={partsPrice} type='number' onChange={(e) => partsPriceSet(e.target.value)} />
        </div>

        <h6 class='center'>심볼류 시세</h6>
        <div id='inputBox'>
          <text id='label'>아케인</text>
          <input id='resultInput' value={arcainPrice} type='number' onChange={(e) => arcainPriceSet(e.target.value)} />
        </div>
        <div id='inputBox'>
          <text id='label'>세르니움</text>
          <input id='resultInput' value={serniumPrice} type='number' onChange={(e) => serniumPriceSet(e.target.value)} />
        </div>
        <div id='inputBox'>
          <text id='label'>아르크스</text>
          <input id='resultInput' value={arcsPrice} type='number' onChange={(e) => arcsPriceSet(e.target.value)} />
        </div>
        <div id='inputBox'>
          <text id='label'>오디움</text>
          <input id='resultInput' value={odiumPrice} type='number' onChange={(e) => odiumPriceSet(e.target.value)} />
        </div>
        <div id='inputBox'>
          <text id='label'>도원경</text>
          <input id='resultInput' value={dowonPrice} type='number' onChange={(e) => dowonPriceSet(e.target.value)} />
        </div>
        <div id='inputBox'>
          <text id='label'>아르테리아</text>
          <input id='resultInput' value={arteriaPrice} type='number' onChange={(e) => arteriaPriceSet(e.target.value)} />
        </div>
        <div id='inputBox'>
          <text id='label'>카르시온</text>
          <input id='resultInput' value={karcionPrice} type='number' onChange={(e) => karcionPriceSet(e.target.value)} />
        </div>
      </div>
    </div>
  );
}

export default App;
